module.exports = __webpack_public_path__ + "assets/img/zip_icon.7bdf30d9.svg";